<template>
  <el-dialog
    title="添加"
    :visible.sync="dialogVisible"
    width="700px"
    class="addExpenseJurDialog"
    @close="dialogCloseHandle"
  >
    <el-form
      class="common_form"
      label-position="left"
      ref="expenseJurDialogForm"
      :rules="rules"
      label-width="120px"
      :model="formData"
    >
      <el-row>
        <el-col :span="24">
          <el-form-item label="申请部门" prop="deptCode">
            <!--            <el-select v-model="formData.deptCode1" @change="deptChange($event,1)" filterable>-->
            <!--              <el-option v-for="item in applyDeptList1" :key="item.deptCode" :label="item.deptName" :value="item.deptCode" />-->
            <!--            </el-select>-->
            <!--            <el-select v-if="applyDeptList2.length > 0" v-model="formData.deptCode2" @change="deptChange($event,2)" filterable>-->
            <!--              <el-option v-for="item in applyDeptList2" :key="item.deptCode" :label="item.deptName" :value="item.deptCode" />-->
            <!--            </el-select>-->
            <!--            <el-select v-if="applyDeptList3.length > 0" v-model="formData.deptCode3" @change="deptChange($event,3)" filterable>-->
            <!--              <el-option v-for="item in applyDeptList3" :key="item.deptCode" :label="item.deptName" :value="item.deptCode" />-->
            <!--            </el-select>-->
            <!--            <el-select v-if="applyDeptList4.length > 0" v-model="formData.deptCode4" @change="deptChange($event,4)" filterable>-->
            <!--              <el-option v-for="item in applyDeptList4" :key="item.deptCode" :label="item.deptName" :value="item.deptCode" />-->
            <!--            </el-select>-->
            <el-cascader
              ref="deptCascader"
              :props="deptProps"
              v-model="formData.deptCode"
              :show-all-levels="false"
            />
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="费用归属部门" prop="expeDeptCode">
            <!--            <el-select v-model="formData.expeDeptCode1" @change="expeDeptChange($event,1)" filterable>-->
            <!--              <el-option v-for="item in expeDeptList1" :key="item.deptCode" :label="item.deptName" :value="item.deptCode"/>-->
            <!--            </el-select>-->
            <!--            <el-select v-if="expeDeptList2.length > 0" v-model="formData.expeDeptCode2" @change="expeDeptChange($event,2)" filterable>-->
            <!--              <el-option v-for="item in expeDeptList2" :key="item.deptCode" :label="item.deptName" :value="item.deptCode" />-->
            <!--            </el-select>-->
            <!--            <el-select v-if="expeDeptList3.length > 0" v-model="formData.expeDeptCode3" @change="expeDeptChange($event,3)" filterable>-->
            <!--              <el-option v-for="item in expeDeptList3" :key="item.deptCode" :label="item.deptName" :value="item.deptCode" />-->
            <!--            </el-select>-->
            <!--            <el-select v-if="expeDeptList4.length > 0" v-model="formData.expeDeptCode4" @change="expeDeptChange($event,4)" filterable>-->
            <!--              <el-option v-for="item in expeDeptList4" :key="item.deptCode" :label="item.deptName" :value="item.deptCode" />-->
            <!--            </el-select>-->
            <el-cascader
              ref="expeDeptCascader"
              :props="deptProps"
              v-model="formData.expeDeptCode"
              :show-all-levels="false"
            >
              <template slot-scope="{ node, data }">
                <span @click="expeDeptClick({ node, data })">
                  {{ data.label }}
                </span>
              </template>
            </el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="费用类型" prop="expeTypeCode">
            <el-select v-model="formData.expeTypeCode">
              <el-option
                v-for="item in expensesTypeList"
                :key="item.expenseTypeCode"
                :label="item.expenseTypeName"
                :value="item.expenseTypeCode"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button plain @click="dialogCloseHandle">取消</el-button>
      <el-button type="primary" @click="submitHandlen">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { expensesJurManagementApi } from "../../service";

export default {
  data() {
    return {
      deptProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          let params = "000";
          if (level > 0) {
            params = node.value;
          }
          if (!node.isLeaf) {
            expensesJurManagementApi.getAllDeptList(params).then((res) => {
              if (res.status === "200") {
                let nodeList = res.data.map((item) => {
                  return {
                    label: item.deptName,
                    value: item.deptCode,
                    leaf: item.type !== "1",
                  };
                });
                resolve(nodeList);
              }
            });
          } else {
            resolve();
          }
        },
      },
      rules: {
        deptCode: [
          { required: true, message: "请选择申请部门", trigger: "change" },
        ],
        expeDeptCode: [
          { required: true, message: "请选择费用归属部门", trigger: "change" },
        ],
        expeTypeCode: [
          { required: true, message: "请选择费用类型", trigger: "change" },
        ],
      },
      dialogVisible: false,
      formData: {},
      // 申请部门
      // applyDeptList1: [],
      // applyDeptList2: [],
      // applyDeptList3: [],
      // applyDeptList4: [],
      // applyDepts: [],
      // 费用归属部门
      // expeDeptList1:[],
      // expeDeptList2:[],
      // expeDeptList3:[],
      // expeDeptList4:[],
      // expeDepts:[],
      // 费用归属类型
      expeTypeList: [],
    };
  },
  props: {
    expenseJurDialogVisible: {
      type: Boolean,
      default: false,
    },
    expensesTypeList: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    expenseJurDialogVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.expenseJurDialogForm.clearValidate();
        });
        // this.getAllDeptList({code: '000', loadFlag: 1});
      }
      this.dialogVisible = val;
    },
  },
  methods: {
    // 最后一个层级，点击文本选中
    expeDeptClick({ node, data }) {
      if (!node.hasChildren) {
        let ary = this.searchParent(node, []);
        this.$set(this.formData, "expeDeptCode", ary);
      }
    },
    searchParent(node, ary) {
      ary.unshift(node.value);
      if (node.parent) {
        this.searchParent(node.parent, ary);
      }
      return ary;
    },
    submitHandlen() {
      this.$refs["expenseJurDialogForm"].validate((valid) => {
        if (valid) {
          let expeTypeObj = this.arrayQuery(
            this.formData.expeTypeCode,
            this.expensesTypeList,
            "expenseTypeCode"
          );
          let deptObj = this.$refs["deptCascader"].getCheckedNodes()[0];
          let expeDeptObj = this.$refs["expeDeptCascader"].getCheckedNodes()[0];
          let data = {
            deptCode: deptObj.value,
            deptName: deptObj.label,
            expeDeptCode: expeDeptObj.value,
            expeDeptName: expeDeptObj.label,
            expeTypeCode: this.formData.expeTypeCode,
            expeTypeName: expeTypeObj.expenseTypeName,
          };
          this.$emit("expenseJurSubHandle", data);
        }
      });
    },
    arrayQuery(val, list, findKey) {
      return list.find((item) => {
        return item[findKey] === val;
      });
    },
    // deptChange(val,index){
    //   let obj = this.arrayQuery(val,this[`applyDeptList${index}`],'deptCode');
    //   this.applyDepts[index-1] = obj;
    //
    //   if(index === 4) return;
    //
    //   // 清空下级部门列表及已选下级code
    //   for(let i = index + 1; i <= 4; i++){
    //     this[`applyDeptList${i}`] = [];
    //     this.$set(this.formData,`deptCode${i}`,'');
    //   }
    //   this.applyDepts.splice(index);
    //
    //   // 获取下级部门list
    //   this.getAllDeptList({code: val, key: `applyDeptList${ index + 1 }` })
    // },
    // expeDeptChange(val,index){
    //   let obj = this.arrayQuery(val,this[`expeDeptList${index}`],'deptCode');
    //   this.expeDepts[index-1] = obj;
    //
    //   if(index === 4) return;
    //
    //   // 清空下级部门列表及已选下级code
    //   for(let i = index + 1; i <= 4; i++){
    //     this[`expeDeptList${i}`] = [];
    //     this.$set(this.formData,`expeDeptCode${i}`,'');
    //   }
    //   this.expeDepts.splice(index);
    //
    //   // 获取下级部门list
    //   this.getAllDeptList({code: val, key: `expeDeptList${ index + 1 }` })
    // },
    dialogCloseHandle() {
      this.formData = {};
      this.$emit("dialogCloseHandle");
    },
    getAllDeptList({ code, key, loadFlag }) {
      expensesJurManagementApi.getAllDeptList(code).then((res) => {
        if (res.status === "200") {
          if (loadFlag) {
            this.applyDeptList1 = res.data;
            this.expeDeptList1 = res.data;
          }
          if (this[key]) {
            this[key] = res.data;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.addExpenseJurDialog {
  ::v-deep.el-form {
    .el-form-item__content {
      > .el-select {
        margin-bottom: 10px;
      }

      > .el-select:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
